// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tracker-clockin-dialog_Wrapper__33wsP {\n  display: flex;\n  flex-direction: column;\n}", "",{"version":3,"sources":["webpack://src/modules/home/components/dialogs/attendance-dialogs/tracker-clockin-dialog/tracker-clockin-dialog.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF","sourcesContent":[".Wrapper {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": "tracker-clockin-dialog_Wrapper__33wsP"
};
export default ___CSS_LOADER_EXPORT___;
